<template>
  <div class="font-normal">
    <div
      style="word-break: normal"
      class="text-xl md:text-2xl mb-6 font-bold w-4/5 mx-auto text-center text-primary flex justify-center"
    >
      {{
        singlePendingAssetDeposit
          ? 'You have a pending asset deposit'
          : 'You have pending asset deposits'
      }}
    </div>
    <div
      class="text-xs md:text-sm text-center text-root-4 md:w-9/12 lg:w-11/12 mx-auto"
    >
      <p style="word-break: normal" class="my-3 flex flex-col">
        <span>
          {{
            singlePendingAssetDeposit
              ? 'You currently have a pending asset deposit of'
              : ''
          }}</span
        >
        <span class="font-bold mt-2">
          {{
            singlePendingAssetDeposit
              ? parseMoneyAsset(
                  pendingAssetDeposit.amount.amount,
                  pendingAssetDeposit.amount.currency
                )
              : ''
          }}</span
        >
      </p>
      <p style="word-break: normal" class="mt-3 flex flex-col mb-7">
        {{
          singlePendingAssetDeposit
            ? 'Would you like to continue with this'
            : 'Would you like to continue with one of them'
        }}?
      </p>
    </div>

    <div class="mx-4 border-none flex items-center justify-center gap-x-5">
      <el-button
        class="w-full bg-white text-primary border-primary rounded-3xl py-3"
        @click="cancel"
        >No</el-button
      >
      <el-button
        class="w-full bg-primary text-white rounded-3xl py-3 border-none"
        @click="continueTransfer"
        >Yes</el-button
      >
    </div>
  </div>
</template>

<script>
import { ParseMoneyAsset } from '@/utils/helpers'
import country from '@/mixins/getCountryDetails.js'
export default {
  mixins: [country],
  computed: {
    singlePendingAssetDeposit () {
      return this.$store.state.transactions.deposits.items.length === 1
    },
    pendingAssetDeposit () {
      return this.singlePendingAssetDeposit
        ? this.$store.state.transactions.deposits.items[0]
        : {}
    }
  },
  methods: {
    continueTransfer () {
      this.$emit('setView', 'pending-transfer')
    },
    cancel () {
      this.$emit('closeDialog')
    },
    parseMoneyAsset (val, country) {
      return ParseMoneyAsset(val, country)
    }
  }
}
</script>

<style></style>
